import { archiveMonths, hotTags } from '@/mocks/homeData';

export default function TagsAndArchive() {
  return (
    <section className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-14">
          {/* 左侧：热门标签 + 订阅提示（纯静态） */}
          <div>
            <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 方向 · 大家都在搜</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950">热门标签</h2>
            <p className="mt-2 text-sm text-foreground-600">点一个标签，就能顺着方向补完一整串相关话题。</p>

            <div className="mt-6 flex flex-wrap gap-2.5">
              {hotTags.map((t) => (
                <a
                  key={t}
                  href="#hot"
                  className="rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition hover:border-accent-300 hover:bg-accent-100 hover:text-accent-800"
                >
                  #{t}
                </a>
              ))}
            </div>

            {/* 纯视觉的“订阅提醒”卡，不接接口 */}
            <div className="mt-8 rounded-xl border border-primary-100 bg-primary-50/70 p-5 md:p-6">
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-notification-3-line text-lg" />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-primary-800">榜首被挤下去前，先来占个座</h3>
                  <p className="mt-1 text-sm text-primary-900/80">热榜话题变化快，盯紧这里基本就不会错过当日重点。订阅提醒功能即将开放。</p>
                </div>
              </div>
              <div className="mt-4 flex flex-col gap-3 sm:flex-row">
                <input
                  type="text"
                  disabled
                  value="话题订阅通道即将开放"
                  className="flex-1 cursor-not-allowed rounded-md border border-primary-200 bg-background-50 px-4 py-2.5 text-sm text-primary-900/50"
                />
                <span className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50">
                  <i className="ri-lock-2-line mr-1.5" />
                  敬请期待
                </span>
              </div>
            </div>
          </div>

          {/* 右侧：往期汇总时间线 */}
          <div id="archive" className="scroll-mt-24">
            <div className="flex items-end justify-between">
              <div>
                <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 存档 · 往期汇总</p>
                <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950">按月的完整合集</h2>
              </div>
              <a href="#archive" className="hidden items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 sm:flex">
                查看全部归档 <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="mt-6 space-y-3">
              {archiveMonths.map((a, i) => (
                <a
                  key={a.period}
                  href="#archive"
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition hover:border-primary-200 hover:bg-primary-50/40 md:p-5"
                >
                  <span
                    className={`flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-lg font-heading font-bold ${
                      i === 0 ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    <span className="text-[9px] font-sans opacity-80">月归档</span>
                    <span className="text-sm">{a.period.replace('20', '20.')}</span>
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate font-medium text-foreground-950 transition group-hover:text-primary-700">{a.topic}</h3>
                    <p className="mt-0.5 text-xs text-foreground-500">
                      收录 {a.count} 条话题 · 含热榜与合集
                    </p>
                  </div>
                  <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition group-hover:text-primary-500" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}